<template>
	
<div class="info_box"  :class="getColorClass(event.tid, event.parents_id)">
 
   <div class="top">{{event.longtitle}}</div>
  
   <div class="detail">
      <div class="left">
         <p class="see_more">{{event.description}} </p>
      </div>
      <div class="right"> 
         <div class="date">{{eventDate}}</div>
         <div class="time">{{event.datetime}}</div>
         <a :href="event.event_url" class="see_more">See more</a>				
      </div>
   </div>


</div>


</template>


<script>

	import store  from './CalendarStoreEvents'
	import moment from 'moment'
	
	export default {
	  	name: 'event-hover',
	  	props: ['event'], 
	  	data () {
		    return {
		    
		    	
		    }
		}, 
		computed :{
			eventDate(){
				

				let start = moment(this.event.dateStart).format('MMM Do')

				if(this.event.dateEnd != '' && this.event.dateEnd != this.event.dateStart){

					let end = ' to '+moment(this.event.dateEnd).format('MMM Do')
					return start +  end
				}
				else{
					return start 
				}
			}
		}, 
		methods : {

			getColorClass(tid, parentTid){
				return store.getColorClass(tid, parentTid)
			}
		

		}
		
	}

</script>


// WEBPACK FOOTER //
// EventHover.vue?08ab9630